module.exports = __webpack_public_path__ + "static/level-3-logo.38b18b79.png";